<template>
  <!-- page2 사이드바 -->
  <div class="template-page2-sidebar">
    <!-- 공개 여부 -->
    <div v-if="isPhishing" class="sidebar-item">
      <div class="sidebar-title">{{$t("Common_Public_Or_Not")}}</div>
      <div class="sidebar-content">
        <div class="buttons">
          <button
            class="basic-btn"
            :class="{ active: isPublic === 1 }"
            @click="() => onSelectValue('isPublic', 1)"
          >
            {{$t("Common_Public")}}
          </button>
          <button
            class="basic-btn"
            :class="{ active: isPublic === 0 }"
            @click="() => onSelectValue('isPublic', 0)"
          >
            {{$t("Common_Private")}}
          </button>
        </div>
      </div>
    </div>
    <!-- 결과 화면 사용 여부 -->
    <div class="sidebar-item">
      <div class="sidebar-title">{{$t("TP_Edit_2_Side_4")}}</div>
      <div class="sidebar-content">
        <div class="buttons">
          <button
            class="basic-btn"
            :class="{ active: screenEnable === 1 }"
            @click="() => onSelectValue('screenEnable', 1)"
          >
            {{$t("TP_Edit_2_Side_5")}}
          </button>
          <button
            class="basic-btn"
            :class="{ active: screenEnable === 0 }"
            @click="() => onSelectValue('screenEnable', 0)"
          >
            {{$t("TP_Edit_2_Side_6")}}
          </button>
        </div>
      </div>
    </div>
    <!-- 피싱 단계 -->
    <div v-if="isPhishing" class="sidebar-item">
      <div class="sidebar-title">{{$t("TP_Edit_2_Side_7")}}</div>
      <div class="sidebar-content">
        <div class="step-area">
          <div class="step-text">{{ phishingLevel - 1 }}</div>
          <div class="step-btn">
            <CaretUpOutlined @click="() => handlePhishingLevel('increase')" />
            <CaretDownOutlined @click="() => handlePhishingLevel('decrease')" />
          </div>
        </div>
      </div>
    </div>
    <!-- 메일 내용 -->
    <div class="sidebar-item">
      <div class="sidebar-title">{{$t("TP_Edit_2_Side_8")}}</div>
      <div class="sidebar-content mail">
        <div
          class="common-bg-item"
          :class="{ active: currentIndex === 0 }"
          @click="() => handleCurrentIndex(0)"
        >
          {{$t("TP_Edit_2_Side_9")}}
        </div>
        <div
          v-if="isPhishing && phishingLevel > 1"
          class="common-bg-item"
          :class="{ active: currentIndex === 1 }"
          @click="() => handleCurrentIndex(1)"
        >
          {{$t("TP_Edit_2_Side_10")}}
        </div>
        <div
          v-if="isPhishing && phishingLevel > 2"
          class="common-bg-item"
          :class="{ active: currentIndex === 2 }"
          @click="() => handleCurrentIndex(2)"
        >
          {{$t("TP_Edit_2_Side_11")}}
        </div>
        <div
          v-if="screenEnable === 1"
          class="common-bg-item"
          :class="{ active: currentIndex === 3 }"
          @click="() => handleCurrentIndex(3)"
        >
          {{$t("TP_Edit_2_Side_12")}}
        </div>
      </div>
    </div>
    <!-- 이미지 업로드 -->
    <div class="sidebar-item">
      <div class="sidebar-title">
        {{$t("TP_Edit_2_Side_13")}}
        <a-tooltip placement="top" overlayClassName="image-upload-tooltip">
          <template v-slot:title>
            <span
              >{{$t("TP_Edit_2_Side_14")}}</span
            >
          </template>
          <img class="help-icon" src="/img/template/btn_qmark.png" />
        </a-tooltip>
      </div>
      <div class="sidebar-content">
        <form class="image-upload-form">
          <div class="file-input" :class="{ active: dragStatus }">
            <label v-if="!!file">{{ file.name }}</label>
            <label v-else>{{$t("TP_Edit_2_Side_15")}}</label>
            <input
              accept="image/bmp, image/jpg, image/jpeg, image/png, image/gif"
              type="file"
              @dragEnter="() => dragHandler(true)"
              @dragLeave="() => dragHandler(false)"
              @change="(e) => handleFile(e)"
            />
          </div>
        </form>
        <div v-if="!!file" class="file-btns">
          <button @click="resetFile">{{$t("Common_Cancel")}}</button>
          <button @click="uploadFile">{{$t("TP_Edit_2_Side_17")}}</button>
        </div>
        <div v-if="!!images" class="uploaed-image-list">
          <div v-for="(image, index) in images" :key="index" class="image-list">
            <div
              class="image-btn"
              :class="{ active: showImageUrl === index }"
              @click="() => handleShowImageUrl(index)"
            >
              <input
                v-if="showImageUrl === index"
                class="image-source"
                type="text"
                spellcheck="false"
                :value="image.imagePath"
                @blur="() => handleShowImageUrl(null)"
                autofocus
              />
              <div v-else class="image-name">{{ image.imageName }}</div>
            </div>
            <CloseOutlined
              class="delete-icon"
              @click="() => handleDeleteFile(image.imageNo)"
              :title="$t('Common_Delete')"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, reactive, toRefs } from "vue";
import {
  CaretUpOutlined,
  CaretDownOutlined,
  CloseOutlined,
} from "@ant-design/icons-vue";
import axios from "axios";
import { apiUrl } from "@/utils/common";
import { useStore } from "vuex";

export default {
  name: "TemplateSidebar",
  props: {
    mode: String,
    templateInfo: Object,
    isPublic: Boolean,
    screenEnable: Boolean,
    phishingLevel: Number,
    currentIndex: Number,
    images: Array,
    onSelectValue: Function,
    handlePhishingLevel: Function,
    handleCurrentIndex: Function,
    getImages: Function,
    isPhishing: Boolean,
  },
  components: { CaretUpOutlined, CaretDownOutlined, CloseOutlined },
  setup(props) {
    const state = reactive({
      file: null,
      dragStatus: false,
      showImageUrl: -1,
    });

    const dragHandler = (value) => {
      state["dragStatus"] = value;
    };

    const handleFile = (e) => {
      state["dragStatus"] = false;
      state["file"] = e.target.files[0];
    };

    const resetFile = () => {
      state["file"] = null;
    };

    const handleShowImageUrl = (index) => {
      state["showImageUrl"] = index;
    };

    const handleDeleteFile = (imageNo) => {
      props.getImages(
        "delete",
        props.images.filter((item) => item.imageNo !== imageNo)
      );
    };

    const uploadFile = async () => {
      const formData = new FormData();
      formData.append("name", state.file.name);
      formData.append("file", state.file);
      formData.append("templateNo", props.templateInfo.templateNo);

      try {
        const response = await axios.post(
          apiUrl + "Template/UploadImage",
          formData
        );
        if (response && !response.data.error) {
          const list = response.data.list;
          const uploadImage = props.images;
          uploadImage.push({
            imageName: list.imageName,
            imagePath: list.imagePath,
            imageNo: list.imageNo,
          });
          props.getImages("upload", uploadImage);
        }
      } catch (error) {
        console.log(error);
      }

      state["file"] = null;
    };

    return {
      ...toRefs(state),
      dragHandler,
      handleFile,
      resetFile,
      uploadFile,
      handleShowImageUrl,
      handleDeleteFile,
    };
  },
};
</script>